import type { I18nOptions } from 'vue-i18n'

import { createI18n } from 'vue-i18n'

import datetimeFormats from './datetimeformats'
// German translations (split files)
import deCommon from './de/common.json'
import deComponents from './de/components.json'
import deEnums from './de/enums.json'
import deFeatures from './de/features.json'
import deFields from './de/fields.json'
import dePages from './de/pages.json'
import deRouter from './de/router.json'
// English translations (split files)
import enCommon from './en/common.json'
import enComponents from './en/components.json'
import enEnums from './en/enums.json'
import enFeatures from './en/features.json'
import enFields from './en/fields.json'
import enPages from './en/pages.json'
import enRouter from './en/router.json'

// Merge split files into locale objects
const de = {
  common: deCommon,
  components: deComponents,
  enums: deEnums,
  features: deFeatures,
  fields: deFields,
  pages: dePages,
  router: deRouter,
}

const en = {
  common: enCommon,
  components: enComponents,
  enums: enEnums,
  features: enFeatures,
  fields: enFields,
  pages: enPages,
  router: enRouter,
}

const options: I18nOptions = {
  legacy: false,
  locale: 'de',
  fallbackLocale: 'en',
  silentFallbackWarn: false,
  silentTranslationWarn: false,
  messages: {
    de,
    en,
  },
  // messages,
  datetimeFormats,
  numberFormats: {
    de: {
      currency: {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'EUR',
      },
    },
    en: {
      currency: {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'EUR',
      },
    },
  },
}

const i18n = createI18n<false, typeof options>(options)

export const setLocale = (locale: 'de' | 'en'): void => {
  i18n.global.locale.value = locale
}

export default { i18n, setLocale }
